import { render } from "./1Navigation.vue?vue&type=template&id=0df55e97&scoped=true"
import script from "./1Navigation.vue?vue&type=script&lang=js"
export * from "./1Navigation.vue?vue&type=script&lang=js"

import "./1Navigation.vue?vue&type=style&index=0&id=0df55e97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df55e97"]])

export default __exports__